import {
  IconAirConditioning,
  IconBattery,
  IconBolt,
  IconChargingPile,
  IconDeviceDesktop,
  IconGauge,
  IconSun,
} from "@tabler/icons-react";

import type { DeviceKind } from "@/api/types";

type DeviceKindMeta = {
  color: string;
  Icon: typeof IconDeviceDesktop;
};

const OTHER_DEVICE_KIND_META: DeviceKindMeta = {
  color: "gray",
  Icon: IconDeviceDesktop,
};

const DEVICE_KIND_META: Record<string, DeviceKindMeta> = {
  battery_stack: { color: "green", Icon: IconBattery },
  pcs: { color: "yellow", Icon: IconBolt },
  power_meter: { color: "blue", Icon: IconGauge },
  pv_inverter: { color: "orange", Icon: IconSun },
  ev_charger: { color: "violet", Icon: IconChargingPile },
  hvac: { color: "cyan", Icon: IconAirConditioning },
  other: OTHER_DEVICE_KIND_META,
};

export function getDeviceKindMeta(kind: DeviceKind | string): DeviceKindMeta {
  return DEVICE_KIND_META[kind] ?? OTHER_DEVICE_KIND_META;
}
